import React from "react";
import FormRadio from "@app/component/form/input/radio/FormRadio";


const AlertFilterOnlyRefundableField: React.FunctionComponent<{ form: any }> = ({form}) => {

    return <>
        <p className="text-sm font-semibold leading-6 text-gray-900 mb-2">Rate</p>
        <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
            <FormRadio name={`filter.onlyRefundable`} form={form} options={[
                {label: "Lowest", value: "false"},
                {label: "Lowest Flex", value: "true"}
            ]}/>
        </div>
    </>
}

export default AlertFilterOnlyRefundableField;